import styled             from 'styled-components';

import { DialogVariants } from 'src/components/common/dialog';
import { ButtonVariants } from 'src/components/common/button';

import { cssFlexColumn,
         Typo,
         themeTypos,
         typoAsCSS,
         themeColors,    
         cssFlexRow     } from 'src/providers/theme/shared';



type CVCheckPieceFilesDialogLookAndFeel = {
  paddings: number[];
  backgroundColor: string;

  captionTypo: Typo;
  captionColor: string;

  messageTypo: Typo;
  messageColor: string;

  gap: number;
  actionsGap: number;

  buttonOkVariant: ButtonVariants;
  buttonCancelVariant: ButtonVariants;
  dialogVariant: DialogVariants;
}

const cvcheckpiecefilesdialog_light: CVCheckPieceFilesDialogLookAndFeel = {
  paddings: [28, 20],

  backgroundColor: themeColors.BackgroundFillLight,

  captionTypo: themeTypos.GRTSKREG_W600_S18_LH24,
  captionColor: themeColors.AccentRed1,

  messageTypo: themeTypos.GRTSKREG_W400_S15_LH22,
  messageColor: themeColors.PrimaryBlack,

  gap: 20,
  actionsGap: 16,

  buttonOkVariant: 'h48bluefill',
  buttonCancelVariant: 'h48blueoutline',
  dialogVariant: 'light',
}

export type CVCheckPieceFilesDialogVariants = 'light';

export const cvcheckpiecefilesdialog_variants: Map<CVCheckPieceFilesDialogVariants, CVCheckPieceFilesDialogLookAndFeel> = 
  new Map<CVCheckPieceFilesDialogVariants, CVCheckPieceFilesDialogLookAndFeel>([
    ['light', cvcheckpiecefilesdialog_light],
  ]);

export const Container = styled.div<{
  lookAndFeel: CVCheckPieceFilesDialogLookAndFeel
}>`
  ${cssFlexColumn};
  gap: ${(args) => args.lookAndFeel.gap}px;

  padding: ${(args) => args.lookAndFeel.paddings[0]}px ${(args) => args.lookAndFeel.paddings[1]}px;
`

export const Caption = styled.div<{
  lookAndFeel: CVCheckPieceFilesDialogLookAndFeel
}>`
  text-align: center;

  ${(args) => typoAsCSS(args.lookAndFeel.captionTypo)};
  color: ${(args) => args.lookAndFeel.captionColor};
`

export const Group = styled.div<{
  lookAndFeel: CVCheckPieceFilesDialogLookAndFeel
}>`
  ${cssFlexColumn};
`

export const Message = styled.div<{
  lookAndFeel: CVCheckPieceFilesDialogLookAndFeel
}>`
  ${(args) => typoAsCSS(args.lookAndFeel.messageTypo)};
  color: ${(args) => args.lookAndFeel.messageColor};
`

export const Actions = styled.div<{
  lookAndFeel: CVCheckPieceFilesDialogLookAndFeel
}>`
  ${cssFlexRow};
  gap: ${(args) => args.lookAndFeel.actionsGap}px;
`
